export const MapPeriodDayToIndex = (periodDay: number) => {
  const defaultValue = 1;
  if (periodDay === 1) return 0;
  if (periodDay === 10) return 1;
  if (periodDay === 15) return 2;
  if (periodDay === 25) return 3;
  return defaultValue;
};
